export default __webpack_public_path__ + "static/ayesa-d496153ddc21caddf5ea61fca0d15841.jpg";